import OUTDOORLogo from "../images/OUTDOOR-logo.svg";
import indexStyles from "../scss/footer-leaf.scss";

const footerLeafTemplate = document.createElement("template");

footerLeafTemplate.innerHTML = `
<div class="LEAF NOTLOGGEDIN">

<div id="footer">
    <style type="text/css">
        ${indexStyles}
    </style>
    <div id="footerContent" class="footerContentHome">
        <div class="footerMenu">
            <div class="footerContainer">
                <!--////////// LOGO ///////////-->
                  <ul class="logo">
                    <li><a href="/"><span>Arc'teryx</span>${OUTDOORLogo}</a></li>
                </ul>
                <!--////////// Contact ///////////-->
                <ul class="contact">
                    <li><a href="/about">About LEAF</a></li>
                    <li><a href="/help/faq">LEAF FAQ</a></li>
                    <li><a href="/stores/find-a-store">Find A Store</a></li>
                </ul>
                <!--////////// FAQ ///////////-->
                <ul class="faq">
                    <li><a href="/help/product-service">Product Service</a></li>
                    <li><a href="/help/sizing">Sizing Charts</a></li>
                    <li><a href="/help/product-care">Product Care</a></li>
                </ul>
                <!--////////// about ///////////-->
                <ul class="about">
                    <li class="desktop-only"><a href="/help">Customer Support Centre</a></li>
                    <li><a href="/help/contact">Contact Us Form</a></li>
                </ul>

                <ul>
                  <li class="mobile-only"><a href="/help">Customer Support Centre</a></li>
                </ul>
            </div>
        </div>

        <div style="clear: both;">
            <!---->
        </div>

        <div class="bottom-bar">
            <ul class="site-services">
                <li>
                    <a href="/help/cookies" data-translation="Cookie-Policy">Cookie Policy</a> |
                    <a href="/help/privacy" data-translation="PrivacyPolicy">Privacy Policy</a> |
                    <span class="US-only">
                        <a href="/help/ca-supply-chains-act">CA Supply Chains Act</a> |
                    </span>
                    <a href="/help/terms-and-conditions">Terms & Conditions</a> |
                    <a href="/help/terms-of-use">Terms of Use</a> |
                    <a href="/help/accessibility">Accessibility</a> |
                    <a href="/help/privacy#do-not-sell-my-personal-information">Do Not Sell My Personal Information</a>
                </li>

                <li class="footWebsiteList websiteSelector">
                    <select title="Please select a website." class="WebsiteSelector">
                        <option value="" data-translation="footer-option-selectWebsite" aria-label="Please select a website."
                            title="Please select a website.">Please select a website.</option>
                        <option class="outdoor" value="//arcteryx.com/" selected="selected" aria-label="arcteryx" title="arcteryx">Arcteryx.com</option>
                        <option class="blog" value="//blog.arcteryx.com" aria-label="blog" title="blog">blog.arcteryx.com</option>
                        <option class="leaf" value="//leaf.arcteryx.com/" data-translation="footer-option-leaf"
                            aria-label="law enforcement and armed forces" title="law enforcement and armed forces">LEAF</option>
                    </select>
                </li>
            </ul>
            <ul class="sites">
                <li class="outdoor" data-value="//arcteryx.com"><a href="//arcteryx.com/" target="_blank" rel="noopener">arcteryx.com</a></li>
                <li class="outlet" data-value="//outlet.arcteryx.com"><a href="//outlet.arcteryx.com" target="_blank" rel="noopener">outlet.arcteryx.com</a></li>
                <li class="blog" data-value="//blog.arcteryx.com"><a href="//blog.arcteryx.com" target="_blank" rel="noopener">blog.arcteryx.com</a></li>
                <li class="leaf selected" data-value="//leaf.arcteryx.com/">leaf.arcteryx.com</li>
            </ul>
            <ul class="sites">
                <li data-value="//www.amersports.com/">Arc’teryx - an <a class="bottom-bar-amer" data-linkid="footer:amer" data-url="https://www.amersports.com/" href="https://www.amersports.com/" target="_blank" rel="noopener" >Amer Sports</a> Brand</li>
            </ul>
        </div>
    </div>
</div>
</div>
`;

export default footerLeafTemplate;
